import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';
import decodeHTMLEntities from '../../../../../../helpers/decodeHTMLEntities';

const Checkbox = ({value, onChange, label}) => {
  return <div className="toggle-block toggle-block--indent-bottom">
    <div className="toggle-component">
      <span className={classNames("toggle-label", {active: !!value})}>{label}</span>
      <div className={classNames("react-toggle", {'react-toggle--checked': value})} onClick={() => {onChange(!value)}}>
        <div className="react-toggle-track">
          <div className="react-toggle-track-check"></div>
          <div className="react-toggle-track-x"></div>
        </div>
      <div className="react-toggle-thumb"></div>
    </div>
  </div>
  </div>
}

class ItemQuestion extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      showAnswer: true,
      showExplanation: true,
    }
  }

  getArrayAnswers = () => {
    const {slide} = this.props;
    const answers = slide.answers;
    return Object.keys(answers).filter(key => key.indexOf('answer_') > -1 && !!answers[key]).map(key => ({value: answers[key], active: answers.correct_answer == key}))
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.slide.id != this.props.slide.id){
      this.setState({
        showAnswer: true,
        showExplanation: true,
      })
    }
  }

  render() {
    const {showAnswer, showExplanation} = this.state;
    const arrayChar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    const {formatMessage} = this.context;
    const {slide} = this.props;

    const question  = slide.question;

    const subject_name = '';

    return (
      <div className="ItemQuestion">
        <div className="question-body_buttons pb-4 pt-4">
          <div className="question-component">
            <div>
              <div className="question-header" >
                <div>
                  <span>#{question.id}</span>
                </div>
                <div>
                  
                  </div>
                 </div>
              </div>
              <div className="question-body">
                <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.question }} />
                <Checkbox value={showAnswer} onChange={(value) => {
                  this.setState({showAnswer: value})
                }} label={'Hide answers'} />
                

                {showAnswer ? <div className="answers-block">
                  {this.getArrayAnswers().map((answer, index) => <div className={classNames("answer-component", {right: answer.active})}>
                    <div className="answer-label">{arrayChar[index]}</div>
                    <div className="answer-content">{decodeHTMLEntities(answer.value)}</div>
                  </div>)}
                </div> : null}

                <Checkbox value={showExplanation} onChange={(value) => {
                  this.setState({showExplanation: value})
                }} label={'Hide explanation'} />

                {showExplanation ? <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.description }} /> : null}
              </div>
            </div>
            </div>
          </div>
    );
  }
}

export default ItemQuestion;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Slide/components/ItemQuestion/index.jsx